import Link from "next/link";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Span } from "src/lib/components/salify-next-layout/default/components/Typography"; // GLOBAL CUSTOM COMPONENTS

//   ==========================================
const NavLink3 = ({
  href,
  text,
  color = "text.primary",
  hoverColor = "primary.main",
  ...props
}) => {
  return (
    <Link href={href}>
      <Span
        sx={{
          color,
          gap: 1,
          lineHeight: 1,
          fontWeight: 600,
          alignItems: "center",
          position: "relative",
          paddingBottom: "4px",
          display: "inline-flex",
          ":after": {
            left: 0,
            bottom: 0,
            width: "0%",
            content: "''",
            height: "2px",
            transition: "0.3s",
            position: "absolute",
            backgroundColor: color,
          },
          ":hover": {
            color: hoverColor,
            "&::after": {
              width: "100%",
              backgroundColor: hoverColor,
            },
          },
        }}
        {...props}
      >
        {text}{" "}
        <ArrowForward
          sx={{
            fontSize: 14,
            flexShrink: 0,
            transform: ({ direction }) => `rotate(${direction === "rtl" ? "180deg" : "0deg"})`,
          }}
        />
      </Span>
    </Link>
  );
};

export default NavLink3;
